import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { EventData } from './models/EventData';

@Injectable({
    providedIn: 'root'
})
export class SeraEventsService {
    private eventSubject = new Subject<EventData>();
    public $eventsQueue = this.eventSubject.asObservable();

    fireEvent(event: EventData) {
        this.eventSubject.next(event);
    }
}
